<template>
  <footer>
      <div class="footerLink">
          <ul>
              <li><a @click.stop="showTermDialog({api: `/api/v1/terms/lgu/service`})">서비스 이용약관</a></li>
              <li><a @click.stop="showTermDialog({api: `/api/v1/terms/lgu/privacy_policy`})"><b>개인정보처리방침</b></a></li>
          </ul>
      </div>

      <div class="footerDesc">
          <strong>서비스 가입/해지/이용문의 1688-4179</strong>
          <b>help@finbridge.co.kr</b>
          <p>핀브릿지(주) 서울시 마포구 독막로3길 45, 5층(서교동, DSM Square) 04044
            <br>사업자등록번호: 719-86-01150
          </p>
      </div>
      <terms-dialog :is-show="isShowTermsDialog" :term-title="termTitle" :term-content="termContent" @close="closeTermDialog"/>
  </footer>
  
</template>

<script>
import TermsDialog from "@/pages/components/TermsDialog"

export default {
    data () {
      return {
        isShowTermsDialog: false,
        termTitle: "",
        termContent: "",
      };
    },
    components: {
      TermsDialog
    },
    methods: {
      showTermDialog({api}) {
        // this.axios.post("/view/getTerms", {termsCd, prdtNo, teleCoCd}).then(res => {
        //   if (res.data.resultCode === "S0000") {
        //     this.termTitle = res.data.termsTitle;
        //     this.termContent = res.data.termsContent;
        //   } else {
        //     this.termTitle = "";
        //     this.termContent = res.data.resultMsg;
        //   }
        //   this.isShowTermsDialog = true;
        // });
        
        this.axios.get(api, {
          baseURL: process.env.VUE_APP_SAFEID_API
        }).then(res => {
          console.log(res)
          const result = res.data[res.data.length - 1];
          this.termTitle = result.title;
          this.termContent = result.content;
          this.isShowTermsDialog = true;
        })
      },
      closeTermDialog() {
        this.isInsurance = false;
        this.termsTitle = "";
        this.termsContent = "";
        this.isShowTermsDialog = false;
      },
    }
};
</script>

<style>
    footer { background-color: #fff;}
    footer .footerLink { height: 42px; border-top: 1px solid #e7e7e7; border-bottom: 1px solid #e7e7e7; text-align: center;}
    footer .footerLink ul li { display: inline-block;}
    footer .footerLink ul li a { font-size: 12px; display: block; color: #666; font-weight: normal; padding:0 10px; position: relative; letter-spacing: -0.33px;line-height: 42px; text-decoration: none; cursor: pointer;}
    footer .footerLink ul li a b { font-weight: bold;font-size: 12px; display: block; color: #666; font-weight: bold; padding:0 10px; position: relative; letter-spacing: -0.33px;line-height: 42px; text-decoration: none; cursor: pointer;}
    footer .footerLink ul li a::before {content:'';  display: block; position: absolute; left: 0; top: 15px; width: 1px; height: 13px; background-color: #c5c5c5; }
    footer .footerLink ul li:first-child a::before { display: none;}
    footer .footerDesc { padding-top: 18px; padding-bottom: 29px; }
    footer .footerDesc strong { font-size: 12px; display: block; text-align: center; color: #333; letter-spacing: -0.33px;  line-height: 18px; padding-bottom: 5px;} 
    footer .footerDesc b { display: block; font-size: 12px; text-align: center; color: #333; padding-bottom: 18px; }
    footer .footerDesc p { font-size: 11px; letter-spacing:-0.3px; color: #999; text-align: center;line-height: 17px;  font-weight: 100;}


    .xBtn { position: absolute; right: 18px; top: 0; height: 48px; line-height: 48px; cursor: pointer; z-index: 1000;}
    .xBtn svg { vertical-align: middle}
    table {border: 1px solid #000; border-collapse: collapse;}
    th {border: 1px solid #000; padding: 5px; vertical-align: middle; text-align: center; background-color: #d5d5d5;}
    td {border: 1px solid #000; padding: 5px; vertical-align: middle; text-align: left;}
    .policyTitle {font-size: 18px; font-weight: bold; align-self: center;}
</style>